export default __webpack_public_path__ + "static/media/fillthegaps.7cc0b230.webp";